export const selectInvestMasterForBuyTrans = (summaryBuyArr, investMaster) => {
    let slctInvestMaster = [];
    for (let i=0; i<summaryBuyArr.length; i++){
        const summaryBuy = summaryBuyArr[i];
        for (let j=0; j<summaryBuy.buyTransArr.length; j++){
            const buyTran = summaryBuy.buyTransArr[j];
            const investMasterObj = investMaster.find(elem => elem.investShortName === buyTran.investShortName);
            if (investMasterObj){
                slctInvestMaster.push(investMasterObj);
            }
        }
    }
    return slctInvestMaster;
}
export default selectInvestMasterForBuyTrans;